import AddPostContainer from "../../../components/miscellaneous/blog/addPost";

const AddPost = () => {
  return <AddPostContainer />;
};

export default AddPost;
